import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

const AddTeam = () => {
  const [title, setTitle] = useState("");
  const [designation, setDesignation] = useState("");
  const [singleImage, setSingleImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("designation", designation);

    if (singleImage) {
      formData.append("singleImage", singleImage);
    }

    try {
      const response = await axios.post(
        "https://mirai-server.vercel.app/upload-team",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      toast.success("Team uploaded successfully!");
      console.log(response.data);
    } catch (error) {
      toast.error("Failed to upload team.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      <div className="w-full py-6 border-b border-gray-300 px-6">
        <h1 className="text-2xl font-bold text-gray-700 font-roboto">
          Add Team
        </h1>
      </div>
      <form
        onSubmit={handleSubmit}
        encType="multipart/form-data"
        className="mx-6 mt-10"
      >
        <div className="flex flex-row gap-5 w-full">
        <div className="w-full">
        <div className="mb-4">
          <label className="text-xl font-roboto text-gray-800">Full Name</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="border border-gray-300 rounded w-full font-roboto text-lg text-gray-600"
            required
          />
        </div>
        <div className="mb-4">
          <label className="text-xl font-roboto text-gray-800">Designation</label>
          <textarea
            value={designation}
            onChange={(e) => setDesignation(e.target.value)}
            className="border border-gray-300 rounded w-full font-roboto text-lg text-gray-600"
            required
          />
        </div>
        </div>
        <div className="w-full flex flex-col mb-4">
          <label className="text-xl font-roboto text-gray-800">Single Image</label>
          <input
            type="file"
            onChange={(e) => setSingleImage(e.target.files[0])}
            accept="image/*"
            required
          />
        </div>
        </div>
        <button
          type="submit"
          className={`px-8 py-2 text-xl font-roboto rounded text-white ${
            loading ? "bg-gray-500" : "bg-blue-600"
          }`}
          disabled={loading}
        >
          {loading ? "Uploading..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default AddTeam;
